import { useSelectableDataCategoriesQuery } from "../../../../processingActivity/hooks/useSelectableDataCategoriesQuery.ts";
import { getDataCategorySelectOptions } from "../../../../incidentLog/incidentLogDialog/CreateEditIncidentLogDialog.hooks.ts";

export function useIncidentLogDataCategoriesField(isPreview: boolean) {
    const { isLoading, allDataCategories } = useSelectableDataCategoriesQuery(!isPreview);

    return { isLoading, dataCategoryOptions: getDataCategorySelectOptions(allDataCategories) };
}
